<template>
    <v-data-table
        v-model="selected"
        dense
        :server-items-length="itemsLength"
        :items="debitNotesData"
        :headers="debitNoteHeaders"
        :loading="loading.data"
        :options.sync="options"
        :footer-props="{ 'items-per-page-options': [5,10,15] }"
        show-select
        single-select
    >
       <template v-slot:[`item.created_at`]="{value}">
            {{formatTimestamp(value)}}
        </template>
        <template v-slot:[`item.amount`]="{value}">
            <p-amount :amount="value"></p-amount>
        </template>
        <template v-slot:[`item.state`]="{value}">
            <p-status :state="value"></p-status>
        </template>

    </v-data-table>
</template>

<script>
import moment from 'moment';

import { getDebitNotesList } from "../../services/sales/debitNote";
import PStatus from '../common/PStatus.vue';
import PAmount from '../common/PAmount';

export default {
    components: { PStatus, PAmount },
    name: "DebitNoteDataTable",
    data() {
        return {
            loading: {
                data: false,
            },
            debitNotesData: [],
            debitNoteHeaders: [
                { text: "Code", value: "code" },
                { text: "Date", value: "created_at" },
                { text: "Document Date", value: "date" },
                { text: "Customer", value: "customer", sortable: false},
                { text: "Description", value: "notes", sortable: false},
                { text: "Amount", value: "amount", sortable: false},
                { text: "State", value: "state", sortable: false},
            ],
            options: {
                itemsPerPage: 10
            },
            itemsLength: 0
        };
    },
    props: {
        value: Array,
        search: Object
    },
    computed: {
        selected: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            }
        }
    },
    watch: {
        options: {
            handler() {
                this.fetchDebitNoteData();
            },
        },
    },
    methods: {
        formatTimestamp(timestamp) {
            return moment(timestamp, true).format("YYYY-MM-DD");
        },
        fetchDebitNoteData() {
            this.loading.data = true;
            let options = {...this.options, ...this.search};
            getDebitNotesList(options)
                .then((response) => {
                    this.debitNotesData = response.data.data;
                    this.itemsLength = response.data.total;
                })
                .finally(() => (this.loading.data = false));
        },
    },
    created() {

    },
};
</script>
